import styled from 'styled-components';

export const Container = styled.div`
  form {
    > div > div {
      margin-bottom: 1rem;
    }
  }
`;
